/** @format */

import { RoomAvailability } from '../@ducks/bookingNew/types';
import { TRoom } from '../@ducks/room/declarations';
import { NAME_PORTAL_CODE } from '../utils/gatsby/constants';
import { Axios } from '../utils/gatsby/createAxiosInstance';
import { utilitySetControllerTimeEnd } from '../utils/helpers/utilitySetControllerTimeEnd';

const getCheckinDate = (checkInDate: string) => `&checkInDate=${checkInDate}`;
const getCheckoutDate = (checkoutDate: string) => `&checkoutDate=${checkoutDate}`;

export const utilityApiGetRoomAvailabilityReduced = ({
  code,
  checkInDate,
  checkOutDate,
  commercialConditionsId,
  portalCode = NAME_PORTAL_CODE,
}: {
  code: TRoom['code'];
  checkInDate?: string;
  checkOutDate?: string;
  commercialConditionsId?: string;
  portalCode?: string;
}) =>
  `/api/Availability/reduced/${encodeURIComponent(code)}?portalCode=${portalCode}${
    checkInDate ? getCheckinDate(checkInDate) : ''
  }${checkOutDate ? getCheckoutDate(checkOutDate) : ''}${
    commercialConditionsId ? `&commercialConditionsId=${commercialConditionsId}` : ''
  }`;

export const apiRoomAvailabilityReduced = async ({
  code,
  checkInDate,
  checkOutDate,
  commercialConditionsId,
  controller,
  portalCode,
}: {
  code: TRoom['code'];
  checkInDate?: string;
  checkOutDate?: string;
  commercialConditionsId?: string;
  controller?: AbortController;
  portalCode?: string;
}): Promise<RoomAvailability | undefined> => {
  const signal = controller?.signal;

  try {
    const URL = utilityApiGetRoomAvailabilityReduced({
      code,
      checkInDate,
      checkOutDate,
      commercialConditionsId,
      portalCode,
    });
    const timeoutId = controller && utilitySetControllerTimeEnd(controller);
    const response = await Axios.get(URL, { signal });
    if (response.status !== 200) throw new Error(URL);
    if (response) clearTimeout(timeoutId);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
